import { render, staticRenderFns } from "./chooseTree.vue?vue&type=template&id=4e36f1f6&scoped=true&"
import script from "./chooseTree.vue?vue&type=script&lang=js&"
export * from "./chooseTree.vue?vue&type=script&lang=js&"
import style0 from "./chooseTree.vue?vue&type=style&index=0&id=4e36f1f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36f1f6",
  null
  
)

export default component.exports